import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    q: 'What is B2B content syndication?',
    a: 'B2B content syndication is the process of republishing and distributing your existing marketing content — such as whitepapers, blogs, case studies, and reports — across trusted third-party websites and platforms. This ensures your content reaches a larger, highly targeted B2B audience while positioning your brand as an industry authority.',
  },
  {
    q: 'How can content syndication benefit my business?',
    a: 'Content syndication helps you expand your reach beyond owned channels, boost brand visibility among key decision-makers, and generate high-quality B2B leads. It also strengthens your SEO through backlinks, enhances thought leadership, and offers a cost-effective way to amplify content performance across multiple platforms.',
  },
  {
    q: 'What makes iTMunch unique as a B2B content syndication service provider?',
    a: 'iTMunch stands out with a vast network of over 1,500 affiliate syndication platforms, reaching more than 1 million users monthly. We collaborate with 90+ global brands, offer rapid turnaround times, and use data-driven targeting to ensure your content reaches verified decision-makers most likely to engage with your offerings.',
  },
  {
    q: 'How does the B2B content syndication process work?',
    a: 'The process includes: (1) reviewing and optimizing your content, (2) defining your target audience, (3) selecting the most relevant syndication platforms, (4) distributing and promoting your content, and (5) tracking performance to generate and nurture high-quality B2B leads.',
  },
  {
    q: 'Which platforms do you use for content syndication?',
    a: 'We partner with a diverse network of trusted global publishers, industry websites, and professional communities tailored to your target market. This ensures maximum visibility and engagement for your content among verified B2B audiences.',
  },
  {
    q: 'How do you measure the success of B2B content syndication campaigns?',
    a: 'Success is measured through lead quality, engagement metrics, website traffic, and conversion rates. We provide comprehensive analytics and reports, so you can track ROI and understand which platforms and audiences drive the best performance.',
  },
  {
    q: 'What types of content work best for B2B syndication?',
    a: 'High-value content such as whitepapers, eBooks, research reports, webinars, and case studies perform best. These assets offer deep insights and solutions that resonate with B2B buyers during the research and consideration phases.',
  },
  {
    q: 'How quickly can I expect results from content syndication?',
    a: 'You can start seeing engagement and leads within days of launching a campaign. However, consistent syndication over several weeks delivers the strongest long-term results and most qualified lead pipelines.',
  },
];

export default function FAQSection() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-32 bg-slate-50"
      aria-label="Frequently Asked Questions"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-sm font-semibold tracking-wide uppercase text-[#4AC5DB] mb-4">
            FAQ
          </span>
          <h2
            data-testid="faq-heading"
            className="font-['Outfit'] text-3xl md:text-5xl font-semibold text-slate-900 tracking-tight"
          >
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-base md:text-lg text-slate-600 leading-relaxed">
            Everything you need to know about B2B content syndication
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white rounded-xl border border-slate-100 px-6 overflow-hidden data-[state=open]:border-[#4AC5DB]/20 data-[state=open]:shadow-sm transition-all"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left text-base font-semibold text-slate-900 hover:text-[#4AC5DB] hover:no-underline py-5 [&[data-state=open]]:text-[#4AC5DB]"
              >
                {faq.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="text-sm md:text-base text-slate-600 leading-relaxed pb-5"
              >
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
